import { marketingCampaignSource } from "@/lib/signupAttribution";

/** Only the billing destination may override the normal authentication flow. */
export function billingReturnTo(value: unknown): string | null {
  if (typeof value !== "string" || value.length > 1000 || !value.startsWith("/") || value.startsWith("//") || value.includes("\\") || Array.from(value).some(c => c.charCodeAt(0) < 32 || c.charCodeAt(0) === 127)) return null;
  try {
    const url = new URL(value, "https://novilot.invalid");
    return url.origin === "https://novilot.invalid" && url.pathname === "/billing"
      ? `${url.pathname}${url.search}${url.hash}` : null;
  } catch {
    return null;
  }
}

/** Read only a known campaign from a validated billing return, never an arbitrary URL. */
export function billingReturnCampaign(value: unknown): string | undefined {
  const target = billingReturnTo(value);
  return target ? marketingCampaignSource(new URL(target, "https://novilot.invalid").searchParams.get("src") ?? undefined) : undefined;
}

/** Cookie-only returns keep the billing offer but cannot assert an old campaign as current. */
export function withoutBillingReturnCampaign(value: unknown): string | null {
  const target = billingReturnTo(value);
  if (!target) return null;
  const url = new URL(target, "https://novilot.invalid");
  if (marketingCampaignSource(url.searchParams.get("src") ?? undefined)) url.searchParams.delete("src");
  return `${url.pathname}${url.search}${url.hash}`;
}

export const AUTH_RETURN_TO_COOKIE = "nc_auth_return_to";
export const authReturnToCookieOptions = {
  httpOnly: true,
  secure: process.env.NODE_ENV === "production",
  sameSite: "lax" as const,
  path: "/",
  maxAge: 24 * 60 * 60,
};
